<template>
  <div class="crumbs" v-if="showSteps">
      <div class="crumbs__container">
        <div data-id="1" :class="'crumb ' + checkCrumb(1)" @click="goBackTo(1,'size')">Size</div>
        <div data-id="2" :class="'crumb ' + checkCrumb(2)" @click="goBackTo(2,'style')">Style</div>
        <div data-id="3" :class="'crumb ' + checkCrumb(3)" @click="goBackTo(3,'fuel')">Fuel Type</div>
        <div data-id="4" :class="'crumb ' + checkCrumb(4)" @click="goBackTo(4,'function')">Oven Function</div>
        <div data-id="5" :class="'crumb ' + checkCrumb(5)" @click="goBackTo(5,'results')">Your Cooker</div>
        <div class="crumb header__buttons">
          <div class="header__buttons__button" @click="go('start')"><i class="far fa-sync-alt"></i></div>
          <div v-if="isWebApp" class="header__buttons__button" @click="go('options')"><i class="fas fa-cog __settings"></i></div>
        </div>
      </div>
  </div>
  <div class="crumbs-title" v-else>
    <div class="crumbs__container">
      <div class="crumb crumb--completed">Your chosen cooker</div>
    </div>
  </div>
</template>
<script>
import { isWebApp } from "../../api/index.js";
export default {
  data: function(){
    return {
      showSteps: true,
      isWebApp: isWebApp()
    }
  },
  mounted: function(){
    this.showSteps = this.$route.matched[1].meta.step != 6;
  },
  watch: {
      '$route'(to, from) {
          this.showSteps = to.meta.step != 6;
      }
  },
  methods: {
    checkCrumb(s) {
      if (!this.$route.matched[1]) {
        return;
      }
      if (this.$route.matched[1].meta.step > s) {
        return "crumb--completed";
      }

      if (this.$route.matched[1].meta.step == s) {
        return "crumb--active";
      }
    },
    go(name){
      this.$router.push({ name });
    },
    goBackTo(s, name) {
      if (this.$route.matched[1].meta.step > s) {
        this.$router.push({ name: name, params: this.$route.params });
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/ui/crumbs.vue